<app-load-general [load]="isLoading"></app-load-general>
<div class="h-full w-full flex flex-col justify-start items-center">
  <div
    class="flex flex-col justify-center items-center bg-[url('assets/img/Fondo-web-resp.jpg')] lg:bg-[url('assets/img/Background-login-web.jpg')] w-full h-full bg-cover"
  >
    <!-- <div class="h-full justify-center flex-col flex "> -->
    <div
      class="p-4 lg:px-4! lg:pb-32! lg:pt-22! lg:max-w-190 lg:m-4 w-full overflow-visible!"
      [ngClass]="{ 'glass-card box-home': !mobile }"
    >
      <div class="w-full h-20 relative -top-45 hidden lg:block">
        <img class="" alt="einteligent" src="assets/icons/logo_holanda_blanco.svg" />
      </div>
      <form
        [formGroup]="loginForm"
        (ngSubmit)="login()"
        class="flex flex-col justify-between gap-7 aa-input-general"
      >
        @if (mobile) {
          <img
            alt="einteligent"
            class="w-full m-auto lg:w-full"
            src="assets/icons/logo_holanda_blanco-mobile.svg"
          />
        } @else {
          <img alt="einteligent" class="w-2/3 m-auto lg:w-full" src="assets/icons/logo_ei.svg" />
        }

        <div class="w-full m-auto">
          <app-input-general
            [label]="'Usuario'"
            [placeholder]="'Usuario'"
            [type]="'text'"
            [formControlGeneral]="getControl(loginForm, 'username')"
          ></app-input-general>
        </div>
        <div class="w-full m-auto">
          <app-input-general
            [label]="'Contraseña'"
            [placeholder]="'Contraseña'"
            [type]="'password'"
            [formControlGeneral]="getControl(loginForm, 'password')"
          ></app-input-general>
        </div>
        <div class="justify-center items-center flex">
          <div class="w-full bg-(--RJ-secundario) h-[1px]"></div>
          <div class="rounded-full! border-3 border-(--RJ-secundario)">
            <button
              class="border-2 border-(--RJ-secundario-light) bg-(--RJ-secundario) rounded-full! size-30! text-white font-bold! text-xl"
              [disabled]="isLoading || loginForm.invalid"
            >
              <div class="flex justify-center items-center gap-4">
                <div>Entrar</div>
              </div>
            </button>
          </div>

          <div class="w-full bg-(--RJ-secundario) h-[1px]"></div>
        </div>
      </form>
    </div>
  </div>
</div>
